export const onLoginSubmitted = () => ({
  type: 'Login Submitted',
});

export const onLoginSuccessful = () => ({
  type: 'Login Successful',
});
